import React, { useContext } from 'react';
import Accordion from 'jl-ui-kit/components/accordion/Accordion';
// eslint-disable-next-line import/no-named-as-default
import NavigationItem from '../navigation-item/NavigationItem';
import styles from './mobile-links.scss';
import { getMobileLinks } from '../../../components/links';
import { UserContext } from '../../../scaffold/UserContext';
import EnvVarsFeaturesContext from '../../../scaffold/EnvVarsFeaturesContext';

function MobileNavigationLinks({ navigationV2Active }) {
  const makeMobileLink = (linkInfo, className) => (
    <a
      href={linkInfo.href}
      alt={linkInfo.title}
      className={className}
      key={linkInfo.title}
    >
      {linkInfo.title}
    </a>
  );

  const {
    userState: {
      user: { signedIn },
    },
  } = useContext(UserContext);
  const {
    envVars: { accountBaseUrl },
  } = useContext(EnvVarsFeaturesContext);

  return getMobileLinks(accountBaseUrl).map(item => {
    let { items } = item;

    if (item.authenticatedItems && signedIn) {
      items = item.authenticatedItems;
    }

    if (navigationV2Active) {
      const mobileLinks = { accountHeaderLinks: [], accordionLinks: [] };

      items.forEach(linkItem => {
        if (linkItem.accountHeaderOnly) {
          mobileLinks.accountHeaderLinks.push(
            makeMobileLink(linkItem, styles.mobileAccountHeaderLink)
          );
        } else {
          mobileLinks.accordionLinks.push(
            makeMobileLink(linkItem, styles.accordionLink)
          );
        }
      });

      return (
        <>
          {mobileLinks.accountHeaderLinks.length > 0 && (
            <div className={styles.mobileAccountHeader}>
              {mobileLinks.accountHeaderLinks}
            </div>
          )}
          <Accordion
            label={<h3 className={styles.accordionTitle}>{item.title}</h3>}
            key={item.title}
            className={styles.accordion}
          >
            <ul key={item.title} className={styles.accordionList}>
              {mobileLinks.accordionLinks}
            </ul>
          </Accordion>
        </>
      );
    }

    return (
      <div
        key={item.title}
        className={styles.container}
        data-testid="mobile-navigation-links"
      >
        <h3 className={styles.title}>
          <a href={item.href}>{item.title}</a>
        </h3>
        <ul className={styles.items}>
          {items.map(subitem => (
            <NavigationItem
              key={subitem.title}
              className={styles.mobile}
              {...subitem}
            />
          ))}
        </ul>
      </div>
    );
  });
}

export default MobileNavigationLinks;
